var exports = {
  "hS": "ForwardModal.module__richInput___VXljWT",
  "bo": "ForwardModal.module__destinationList___VXljWT",
  "NG": "ForwardModal.module__footerSection___VXljWT",
  "vm": "ForwardModal.module__messageInputContainer___VXljWT",
  "hj": "ForwardModal.module__messageInputContainerDisabled___VXljWT",
  "zt": "ForwardModal.module__messageInputContainerWithCounter___VXljWT",
  "pn": "ForwardModal.module__messageInputContainerWithNotice___VXljWT",
  "XK": "ForwardModal.module__slowmodeNotice___VXljWT",
  "X8": "ForwardModal.module__messageInputActions___VXljWT",
  "Vr": "ForwardModal.module__emojiPickerButton___VXljWT",
  "Z8": "ForwardModal.module__emojiPickerButtonActive___VXljWT",
  "mI": "ForwardModal.module__emojiIcon___VXljWT",
};

module.exports = exports;
